/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, TextField, Typography, Tooltip, IconButton, Button, Chip, Collapse, Divider, FormControl, FormControlLabel, FormLabel,Checkbox, RadioGroup, Radio, Tabs, Tab, 
    CircularProgress, List, ListSubheader, ListItem, ListItemText, InputLabel, Input, Select, MenuItem } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import { ExpandLess, ExpandMore, Edit, Delete, Clear } from '@material-ui/icons'
import Filter from '../../../components/Filter/Filter'
import CTAConfig from '../../../components/CTAConfig/CTAConfig';
import ExternalSources from '../../../components/ExternalSources/ExternalSources';

import Actions from '../../../../../fluid/Actions/ActionFactory'

import { v4 as uuidv4 } from 'uuid';

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const AntTabs = withStyles({
    root: {
      borderBottom: '1px solid #e8e8e8',
    },
    indicator: {
      backgroundColor: '#1890ff',
    },
})(Tabs);

const AntTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        minWidth: 72,
        fontWeight: theme.typography.fontWeightRegular,
        marginRight: theme.spacing(2),
        padding : theme.spacing(1),
        fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        ].join(','),
        '&:hover': {
        color: '#40a9ff',
        opacity: 1,
        },
        '&$selected': {
        color: '#1890ff',
        fontWeight: theme.typography.fontWeightMedium,
        },
        '&:focus': {
        color: '#40a9ff',
        },
    },
    selected: {},
}))((props) => <Tab disableRipple {...props} />);

const styles = theme => ({

})

class SearchScreen extends Component {
    state = {
        name : null,
        ic_loading : false,
        ic_object_list : [],
        loading_ic_objects : false,
        ic_list : [],
        url : null,
        selected_ic_list : [],
        selected_ic_object_list : [],
        search_type : null,
        search_fields : [],
        icWVFieldMap : [],
        show_app_bar : null,
        show_search_bar : null,
        copy_to_parent : null,
        show_in_sidebar : null,
        show_settings : true,
        setting_tab_index : 0,
        filters : [],
        temp_field_name : "",
        cur_ic_field_map : "",
        selected_ic_field_map : null,
        external_sources : [],
        editing_external_source_id : null,
        cta_config : [],
        screen_cta_config : {}
    }

    componentWillMount () {
        this.generateStateFromConfig()
    }

    componentDidUpdate (prevProps) {
        if (JSON.stringify(prevProps.config) !== JSON.stringify(this.props.config)) {
            this.generateStateFromConfig()
        }
    }

    generatePath = (name) => {
        if (name !== null) {
            let path = name.toLowerCase()
            path = path.replace(/ /g,"_")
            path = '/' + path
            return path
        } else {
            return '/_'
        }
    }

    generateFieldStringURL = () => {
        if (this.state.search_type === 'multifield') {
            let field_strings = ""
            this.state.search_fields.map((field, i) => {
                if (i === this.state.search_fields.length -1) {
                    field_strings = field_strings + field.name + "=[Add Search Text Here]"
                } else {
                    field_strings = field_strings + field.name + "=[Add Search Text Here]&"
                }
            })
            return field_strings
        } else {
            return "searchString="
        }
    }

    generateDeeplink = (name) => {
        let url = this.generatePath(name)
        let deep_link = url + "?" +  (this.state.show_app_bar ? "" : "showAppbar=false&") + (this.state.show_search_bar ? "" : "showSearchbar=false&") + this.generateFieldStringURL()
        return deep_link
    }

    generateStateFromConfig = () => {
        let selected_ic_list = this.props.config.default_params !== null ? this.props.config.default_params.icList : []
        let selected_ic_object_list = selected_ic_list.map(ic => this.props.ic_list.find(ic_obj => ic_obj.name === ic))
        this.setState({
            ...this.state,
            name : this.props.config.name,
            selected_ic_list : selected_ic_list,
            selected_ic_object_list : selected_ic_object_list,
            url : this.props.config.route,
            search_type : this.props.config.default_params !== null ? this.props.config.default_params.search_type ? this.props.config.default_params.search_type  : 'freetext' : 'freetext',
            search_fields : this.props.config.default_params !== null ? this.props.config.default_params.search_fields ? this.props.config.default_params.search_fields  : [] : [],
            icWVFieldMap : this.props.config.default_params !== null ? this.props.config.default_params.icWVFieldMap ? this.props.config.default_params.icWVFieldMap  : [] : [],
            show_app_bar : this.props.config.default_params !== null ? this.props.config.default_params.showAppbar : null,
            show_search_bar : this.props.config.default_params !== null ? this.props.config.default_params.showSearchbar : null,
            copy_to_parent : this.props.config.default_params !== null ? this.props.config.default_params.copyToParent : null,
            show_in_sidebar : this.props.config.show_in_sidebar !== undefined ? this.props.config.show_in_sidebar : true,
            show_settings : this.props.editing_id === this.props.config.id ? true : false,
            filters : this.props.config.default_params !== null ? this.props.config.default_params.filters : [],
            external_sources : this.props.config.default_params !== null ? this.props.config.default_params.external_sources ? this.props.config.default_params.external_sources : [] : [],
            cta_config : this.props.config.default_params !== null ? this.props.config.default_params.cta_config ? this.props.config.default_params.cta_config : [] : [],
            screen_cta_config : this.props.config.default_params !== null ? this.props.config.default_params.screen_cta_config ? this.props.config.default_params.screen_cta_config : null : null
        }, () => console.log("Search State generated: ", this.state))
    }

    generateConfigFromState = () => {
        let config = this.props.config
        config.name = this.state.name
        config.route = this.generatePath(this.state.name)
        config.show_in_sidebar = this.state.show_in_sidebar
        config.default_params.icList = this.state.selected_ic_list
        config.default_params.search_type = this.state.search_type
        config.default_params.search_fields = this.state.search_fields
        config.default_params.icWVFieldMap = this.state.icWVFieldMap
        config.default_params.showAppbar = this.state.show_app_bar
        config.default_params.showSearchbar = this.state.show_search_bar
        config.default_params.copyToParent = this.state.copy_to_parent
        config.default_params.filters = this.state.filters
        config.default_params.external_sources = this.state.external_sources
        config.default_params.cta_config = this.state.cta_config
        config.default_params.screen_cta_config = this.state.screen_cta_config
        console.log("Generating Case Config : ", config)

        return config
    }

    getICs = () => {
        this.setState({...this.state, ic_loading : true}, () => {
            Actions ('http_request', {
                url : "/sainapse/information_channel",
                method : "get",
                data : {}
            }).then(res => {
                let ic_list2 = res.data.result.map(ic => ic.name)
                this.setState({...this.state, ic_loading : false, ic_list : ic_list2, ic_object_list : res.data.result })
            }).catch(err => {
                this.setState({...this.state, ic_loading : false, ic_list : [], ic_object_list : []})
            })
        })
    }

    getICObject = (ic_name) => {
        let ic_object = this.props.ic_list.find(ic => ic.name === ic_name)
        return ic_object
    }

    updateState = (state_key, value) => {
        this.setState({ ...this.state, [state_key] : value })
    }

    isValid = () => {
        if (this.state.name !== null && this.state.selected_ic_list.length > 0) {
            if (this.state.search_type === 'multifield') {
                if (this.state.search_fields.length > 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        } else {
            return false
        }
    }

    renderName = (edit) => {
        if (edit) {
            return (
                <div style = {{width : '25%', flexGrow: 1, margin : '5px', borderRadius : '5px', padding : '5px'}}>
                    <TextField
                        style = {{width : '100%'}}
                        label = "Name"
                        value = {this.state.name}
                        onChange = {(event) => {
                            if (event.target.value !== "") {
                                this.updateState('name', event.target.value)
                            } else {
                                this.updateState('name', null)
                            }
                        }}
                        variant = 'filled'
                        size = 'small'
                    />
                </div>
            )
        } else {
            return (
                <div style = {{width : '25%', flexGrow: 1, margin : '5px', border : '1px solid rgba(0,0,0,0.12)', borderRadius : '5px', padding : '5px'}}>
                    <Typography variant = 'subtitle2' color = 'primary'>Name</Typography>
                    <Typography variant = 'body2'>{this.props.config.name}</Typography>
                </div>
            )
        }
    }

    renderICList = (edit) => {
        return (
            <div style = {{width : '50%',margin : '5px', borderRadius : '5px', padding : '5px'}}>
                    <Autocomplete
                        multiple
                        id="tags-standard"
                        options={this.props.ic_list.map(ic_obj => ic_obj.name)}
                        value = {this.state.selected_ic_list}
                        //onOpen = {() => this.getICs()}
                        onChange = {(event, newValue) => {
                            let selected_ic_list = newValue
                            let selected_ic_object_list = selected_ic_list.map(ic => this.props.ic_list.find(ic_obj => ic_obj.name === ic))
                            let cta_config = []
                            selected_ic_list.map(ic => {
                                if(this.props.config.default_params.cta_config.find(config => config.ic_name === ic)) {
                                    cta_config.push(this.props.config.default_params.cta_config.find(config => config.ic_name === ic))
                                }
                            })
                            this.setState({...this.state, selected_ic_list : newValue, selected_ic_object_list : selected_ic_object_list, setting_tab_index : 0, cta_config : cta_config}, () => this.generateICMaps())
                        }}
                        loading = {this.state.ic_loading}
                        disabled = {!edit}
                        // onBlur = {this.generateICMaps}
                        ChipProps = {{
                            color : 'primary',
                            size : 'small'
                        }}
                        renderInput={(params) => (
                            <TextField
                            {...params}
                            label="Default Information Channels to search across"
                            variant = 'filled'
                            size = 'small'
                            />
                        )}
                    />
                </div>
        )
    }

    renderActions = (edit) => {
        if (!edit) {
            // if (this.state.name !== null && this.state.selected_ic_list.length > 0) {
            //     return (
            //         <div style = {{margin : '5px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'space-around'}}>
            //             <Tooltip title = 'Delete'>
            //                 <IconButton color = 'secondary' onClick = {() => this.props.delete(this.props.config)}>
            //                     <Delete fontSize = 'small'/>
            //                 </IconButton>
            //             </Tooltip>
            //             <Tooltip title = 'Edit' >
            //                 <IconButton onClick = {() => {
            //                     this.setState({...this.state, show_settings : true}, () => {
            //                         this.props.enable_edit(this.props.config)
            //                     })
            //                 }}>
            //                     <Edit fontSize = 'small'/>
            //                 </IconButton>
            //             </Tooltip>
            //         </div>
            //     )
            // }
            return (
                <div style = {{margin : '5px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'space-around'}}>
                    <Tooltip title = 'Delete'>
                        <IconButton color = 'secondary' onClick = {() => this.props.delete(this.props.config)}>
                            <Delete fontSize = 'small'/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title = 'Edit' >
                        <IconButton onClick = {() => {
                            this.setState({...this.state, show_settings : true}, () => {
                                this.props.enable_edit(this.props.config)
                            })
                        }}>
                            <Edit fontSize = 'small'/>
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    }

    copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
    }

    renderSettingsTabContent = (edit) => {
        return (
            <div style = {{width : '100%', padding : '5px'}}>
                    <Typography style = {{display : 'block'}} variant = 'subtitle2'>Settings</Typography>
                    <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', padding : '5px', flexWrap : 'wrap'}}>
                        <div style = {{width : '25%'}}>
                            <FormControlLabel
                                disabled = {!edit}
                                control={
                                    <Checkbox
                                      checked={this.state.show_app_bar}
                                      onChange={(event) => this.updateState("show_app_bar", event.target.checked)}
                                      name="show_app_bar"
                                      color="primary"
                                    />
                                  }
                                label="Show Application Bar"
                            />
                        </div>
                        <div style = {{width : '25%'}}>
                            <FormControlLabel
                                disabled = {!edit}
                                control={
                                    <Checkbox
                                      checked={this.state.show_search_bar}
                                      onChange={(event) => this.updateState("show_search_bar", event.target.checked)}
                                      name="show_search_bar"
                                      color="primary"
                                    />
                                  }
                                label="Show Search Bar"
                            />
                        </div>
                        <div style = {{width : '25%'}}>
                            <FormControlLabel
                                disabled = {!edit}
                                control={
                                    <Checkbox
                                      checked={this.state.copy_to_parent}
                                      onChange={(event) => this.updateState("copy_to_parent", event.target.checked)}
                                      name="copy_to_parent"
                                      color="primary"
                                    />
                                  }
                                label="Copy Recommendation to parent window"
                            />
                        </div>
                        <div style = {{width : '25%'}}>
                            <FormControlLabel
                                disabled = {!edit}
                                control={
                                    <Checkbox
                                      checked={this.state.show_in_sidebar}
                                      onChange={(event) => this.updateState("show_in_sidebar", event.target.checked)}
                                      name="show_in_sidebar"
                                      color="primary"
                                    />
                                  }
                                label="Show link in the sidebar menu"
                            />
                        </div>
                    </div>
                    <div style = {{marginTop : '5px', padding: '10px', borderTop : '1px solid rgba(0,0,0,0.12)'}}>
                        <FormControl component="fieldset" disabled = {!edit}>
                            <FormLabel component="legend">Search Type</FormLabel>
                            <RadioGroup aria-label="gender" name="gender1" value={this.state.search_type} onChange={(event) => {
                                if (event.target.value === 'freetext') {
                                    this.setState({...this.state, search_type : event.target.value, search_fields : []})
                                } else {
                                    this.setState({...this.state, search_type : event.target.value})
                                }
                            }}>
                                <FormControlLabel value="freetext" control={<Radio />} label="Freetext Search" />
                                <FormControlLabel value="multifield" control={<Radio />} label="Multifield Search" />
                            </RadioGroup>
                        </FormControl>
                    </div>
                    {this.renderFieldSettings(edit)}
                </div>
        )
    }

    renderFieldSettings = (edit) => {
        if (this.state.search_type === 'multifield') {
            return (
                <div>
                    <Typography variant = 'overline'>Search Fields</Typography>
                    <Divider/>
                    <div style = {{display : 'flex', flexDirection : 'row', padding : '10px'}}>
                        <TextField
                            error = {this.fieldNameExists()}
                            label = "Add Search Field"
                            disabled = {!edit}
                            placeholder = 'Field Name'
                            value = {this.state.temp_field_name}
                            onChange = {(event) => this.setState({...this.state, temp_field_name : event.target.value})}
                            size = 'small'
                            variant = 'outlined'
                        />
                        <Button 
                            style = {{marginLeft : '10px'}}
                            disabled = {this.state.temp_field_name === "" || this.fieldNameExists()}
                            color = 'primary'
                            size='small'
                            onClick = {this.addField}
                        >Add Field</Button>
                    </div>
                    <div style = {{display : 'flex', flexDirection : 'row', padding : '10px'}}>
                        {this.state.search_fields.map(field => {
                            return (
                                <Chip
                                    disabled = {!edit}
                                    style = {{marginRight : '10px'}}
                                    label={field.name}
                                    onDelete={() => this.deleteField(field.name)}
                                    color="primary"
                                />
                            )   
                        })}
                    </div>
                </div>
            )
        }
    }

    fieldNameExists = () => {
        let fields = [...this.state.search_fields]
        let temp_field_index = fields.findIndex(field => field.name === this.state.temp_field_name)
        if (temp_field_index === -1) {
            return false
        } else {
            return true
        }
    }

    addField = () => {
        let fields = [...this.state.search_fields]

        let new_field = {
            name : this.state.temp_field_name
        }
        fields.push(new_field)

        this.setState({...this.state, temp_field_name : "",search_fields : fields})
    }

    deleteField = (name) => {
        let fields = [...this.state.search_fields]
        let delete_field_index = fields.findIndex(field => field.name === name)

        if (delete_field_index !== -1) {
            fields.splice(delete_field_index, 1)
            this.setState({...this.state, search_fields : fields})
        }
    }

    renderFieldMapsTabContent = (edit) => {
        return (
            <div style = {{width : '100%', padding : '5px'}}>
                <Typography style = {{display : 'block'}} variant = 'subtitle2'>Field Maps</Typography>
                <Divider/>
                <div style = {{margin : '5px', padding : '10px', width : '100%', height : '50vh', display : 'flex', flexDirection : 'row'}}>
                    <div style = {{width : '30%', height : '100%', borderRight : '1px solid rgba(0,0,0,0.12)'}}>
                        <List
                            subheader={
                                <ListSubheader component="div" id="nested-list-subheader">
                                    Information Channels
                                </ListSubheader>
                            }
                        >
                            {this.state.selected_ic_list.map(ic => {
                                return (
                                    <ListItem 
                                        button
                                        selected = {this.state.cur_ic_field_map === ic}
                                        onClick = {() => this.setState({...this.state, cur_ic_field_map : ic})}
                                    >
                                        <ListItemText primary={ic} />
                                    </ListItem>
                                )
                            })}
                        </List>
                    </div>
                    <div style = {{width : '75%', height : '100%', padding : '10px', overflow : 'auto', backgroundColor : '#F0F0F0'}}>
                        <Typography variant = 'subtitle2' color = 'textSecondary'>World View maps</Typography>
                        {this.renderWVFieldMap(edit)}
                    </div>
                </div>
            </div>
        )
    }

    generateICMaps = () => {
        let ic_map = []
        let selected_ic_list = [...this.state.selected_ic_list]

        ic_map = selected_ic_list.map(ic => this.getICMap(ic))

        console.log("CogSearch :: IC Maps generated in state : ", ic_map)
        this.setState({...this.state, icWVFieldMap : ic_map})
    }

    getICMap = (ic) => {
        console.log("Search Screen :: IC Field Maps : ", this.state.icWVFieldMap)
        let ic_map_index = this.state.icWVFieldMap.findIndex(ic_map => ic_map.ic_name === ic) 
        console.log("Search Screen :: Looking for IC Field Map : ", ic)
        console.log("Search Screen :: IC Field Map Index : ", ic_map_index)
        if (ic_map_index === -1) {
            let ic_wv_map = {
                ic_name : ic,
                configs : []
            }
    
            let selected_ic = this.props.ic_list.find(ic_object => ic_object.name === ic)
    
            ic_wv_map.configs = selected_ic.world_view.configs.map(config => {
                let op_config = {
                    operation : config.operation,
                    fields : []
                }
                let predictor_fields = config.fields.filter(field => field.role === 'Predictor')

                op_config.fields = predictor_fields.map(field => {
                    return {
                        name : field.name,
                        base : []
                    }
                })

                return op_config
            })

            let ic_wv_map_state = [...this.state.icWVFieldMap]
            ic_wv_map_state.push(ic_wv_map)

            return ic_wv_map
            // this.setState({...this.state, cur_ic_field_map : ic, icWVFieldMap : ic_wv_map_state})
        } else {
            // this.setState({...this.state, cur_ic_field_map : ic})
            return this.state.icWVFieldMap[ic_map_index]
        }
    }

    renderWVFieldMap = (edit) => {
        let wv_map_index = this.state.icWVFieldMap.findIndex(ic_map => ic_map.ic_name === this.state.cur_ic_field_map)
        console.log("CogSearch :: IC Map :", this.state.icWVFieldMap)
        console.log("CogSearch :: Selected IC Map :", this.state.icWVFieldMap[wv_map_index])
        if (wv_map_index !== -1) {
            let wv_map = this.state.icWVFieldMap[wv_map_index]

            let reco_config = wv_map.configs.find(config => config.operation === 'Recommend')
            console.log("CogSearch :: Reco Config : ", reco_config)
            let class_config = wv_map.configs.find(config => config.operation === 'Classify')
            console.log("CogSearch :: Class Config : ", class_config)
            return (
                <Fragment>
                    {reco_config && 
                    <div>
                        <Typography variant = 'subtitle2'>Recommendation Predictors</Typography>
                        {reco_config.fields.map(field => {
                            return (
                                <Paper style = {{width : '100%', display : 'flex', flexDirection : 'row', alignContent : 'center', marginTop : '5px', alignItems : 'center'}}>
                                    <div style = {{width : '50%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                        <Typography style = {{margin: '25px'}} variant = 'body2'>{field.name}</Typography>
                                    </div>
                                    <div style = {{width : '50%', flexDirection : 'row', alignItems : 'center', justifyContent : 'center', paddingRight : '10px'}}>
                                        <Autocomplete
                                            multiple
                                            id="tags-standard"
                                            disabled = {!edit}
                                            options={this.state.search_fields}
                                            getOptionLabel={(option) => option.name}
                                            onChange = {(event, newValue) => this.setFieldMapping(this.state.cur_ic_field_map, reco_config.operation, field.name, newValue)}
                                            value = {this.getFieldMapping(this.state.cur_ic_field_map, reco_config.operation, field.name)}
                                            ChipProps = {{
                                                color : 'primary',
                                                size : 'small'
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                {...params}
                                                label="Map to Search Fields"
                                                variant = 'filled'
                                                size = 'small'
                                                />
                                            )}
                                        />
                                    </div>
                                </Paper>
                            )
                        })}
                    </div>}
                    {class_config && 
                    <div style = {{marginTop : '10px', borderTop : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography variant = 'subtitle2'>Classification Predictors</Typography>
                        {class_config.fields.map(field => {
                            return (
                                <Paper style = {{width : '100%', display : 'flex', flexDirection : 'row', alignContent : 'center', marginTop : '5px', alignItems : 'center'}}>
                                    <div style = {{width : '50%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                        <Typography style = {{margin: '25px'}} variant = 'body2'>{field.name}</Typography>
                                    </div>
                                    <div style = {{width : '50%', flexDirection : 'row', alignItems : 'center', justifyContent : 'center', paddingRight : '10px'}}>
                                        <Autocomplete
                                            multiple
                                            id="tags-standard"
                                            disabled = {!edit}
                                            options={this.state.search_fields}
                                            getOptionLabel={(option) => option.name}
                                            onChange = {(event, newValue) => this.setFieldMapping(this.state.cur_ic_field_map, class_config.operation, field.name, newValue)}
                                            value = {this.getFieldMapping(this.state.cur_ic_field_map, class_config.operation, field.name)}
                                            ChipProps = {{
                                                color : 'primary',
                                                size : 'small'
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                {...params}
                                                label="Map to Search Fields"
                                                variant = 'filled'
                                                size = 'small'
                                                />
                                            )}
                                        />
                                    </div>
                                </Paper>
                            )
                        })}
                    </div>}
                </Fragment>
            )
        }
    }

    setFieldMapping = (ic_name, operation, field_name, newValue) => {
        let ic_maps = [...this.state.icWVFieldMap]
        let ic_map = ic_maps[ic_maps.findIndex(ic => ic.ic_name === ic_name)]
        let config = ic_map.configs.find(config => config.operation === operation)
        let field = config.fields.find(field => field.name === field_name)
        field.base = newValue
        ic_maps[ic_maps.findIndex(ic => ic.ic_name === ic_name)] = ic_map

        this.setState({...this.state, icWVFieldMap : ic_maps}, () => console.log("CogSearch :: Setting WV Field map : ", this.state.icWVFieldMap))
    }

    getFieldMapping = (ic_name, operation, field_name) => {
        let ic_maps = [...this.state.icWVFieldMap]
        let ic_map = ic_maps[ic_maps.findIndex(ic => ic.ic_name === ic_name)]
        let config = ic_map.configs.find(config => config.operation === operation)
        let field = config.fields.find(field => field.name === field_name)
        console.log("CogSearch :: AutoComplete Vallue :", field.base)
        return field.base
    }

    renderDeeplinksTabContent = () => {
        return (
            <div style = {{width : '100%', padding : '5px'}}>
                <Typography style = {{display : 'block'}} variant = 'subtitle2'>Deeplinks</Typography>
                <Divider/>
                <div style = {{margin : '5px', padding : '10px', width : '100%', display : 'flex', flexDirection : 'row'}}>
                    <div>
                        <Typography variant = 'body2' color = 'primary'>Deeplink to this screen<em>(Append Search String in the end)</em></Typography>
                        <Tooltip title = 'Click to copy'>
                            <Typography 
                                onClick = {(event) => this.copyToClipboard(window.location.origin + '/#' + this.generateDeeplink(this.state.name))} 
                                style = {{cursor : 'pointer'}} 
                                variant = 'body2'
                            >
                                {window.location.origin + '/#' + this.generateDeeplink(this.state.name)}
                            </Typography>
                        </Tooltip>
                    </div>
                </div>
            </div>
        )
    }

    saveFilters = (filters) => {
        console.log("Filters :: Saving filters : ", filters)
        this.setState({...this.state, filters : filters})
    }

    getRelevantICs = () => {
        let ic_object_list = []
        this.setState({...this.state, loading_ic_objects : true}, () => {
            Actions('http_request', {
                url : "/sainapse/information_channel",
                method : "get",
                data : {}
            }).then(res => {
                let ic_list = res.data.result
                // let default_ic = ic_list.find(ic => ic.name === this.state.icName)
                // icObjects.push(default_ic)
                this.state.selected_ic_list.forEach(source => {
                    let ic_source = ic_list.find(ic => ic.name === source)
                    ic_object_list.push(ic_source)
                })

                this.setState({...this.state.adding_source, ic_object_list : ic_object_list, loading_ic_objects : false}, () => console.log("Got IC List For Filter: ", this.state))
            })
        })
    }

    renderFiltersTabContent = () => {
        console.log("Filter State While rendering : ", this.state.loading_ic_objects, this.props.ic_list)
        // if (!this.state.loading_ic_objects && this.props.ic_list.length === 0) {
        //     this.getRelevantICs()
        // } else if (this.state.loading_ic_objects && this.props.ic_list.length === 0) {
        //     return (
        //         <div style = {{width : '100%', height : '50vh', padding : '5px', display : 'flex', flexDirection : 'row', justifyContent :'center', alignItems : 'center'}}>
        //             <CircularProgress color = "primary"/>
        //         </div>
        //     )
        // } else 
        if (this.state.selected_ic_object_list.length > 0) {
            return (
                <div style = {{width : '100%', padding : '5px'}}>
                    {/* <Filter ic_list = {this.state.icObjects} filter_config = {this.state.filters} save_filters = {(filters) => this.saveFilters(filters)}/> */}
                    <Filter ic_list = {this.state.selected_ic_object_list} filter_config = {this.state.filters} save_filters = {(filters) => this.saveFilters(filters)}/>
                </div>
            )
        } else {
            return (
                <div style = {{width : '100%', padding : '5px'}}>
                    {/* <Filter ic_list = {this.state.icObjects} filter_config = {this.state.filters} save_filters = {(filters) => this.saveFilters(filters)}/> */}
                    <Typography>ICs are not selected.</Typography>
                </div>
            )
        }
        // return (
        //     <div style = {{width : '100%', padding : '5px'}}>
        //         <Filter ic_list = {this.props.config.default_params.icObjectList} filter_config = {this.state.filters} save_filters = {(filters) => this.saveFilters(filters)}/>
        //     </div>
        // )
    }

    renderExternalSources = (edit) => {
        return (
            <ExternalSources
                screen = {"SearchScreen"}
                external_sources = {this.state.external_sources}
                update_parent = {(external_sources) => {this.setState({...this.state, external_sources : external_sources})}}
                search_fields = {this.state.search_fields}
                search_type = {this.state.search_type}
                edit = {edit}
            />
            // <div style = {{width : '100%', padding : '5px'}}>
            //     <Typography style = {{display : 'block'}} variant = 'subtitle2'>External Sources</Typography>
            //     <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
            //     <div style = {{padding : '10px'}}>
            //         {this.state.external_sources.map(external_source => {
            //             return this.renderExternalSource(external_source, edit)
            //         })}
            //     </div>
            //     <Button
            //         variant = 'outlined'
            //         style = {{marginLeft : '10px'}}
            //         disabled = {!edit}
            //         color = 'primary'
            //         size='small'
            //         onClick = {() => this.addExternalSource()} 
            //     >Add External Source</Button>
            // </div>
        )
    }

    addExternalSource = () => {
        const external_source_temp = {
            id : uuidv4(),
            link_id : "",
            link_name : "",
            query_map : []
        }

        let external_sources = [...this.state.external_sources]
        external_sources.push(external_source_temp)

        this.setState({...this.state, external_sources : external_sources})
    }

    deleteExternalSource = (source_id) => {
        let external_sources = [...this.state.external_sources]
        let source_index = external_sources.findIndex(src => src.id === source_id)
        external_sources.splice(source_index, 1)
        this.setState({...this.state, external_sources : external_sources})
    }

    renderExternalSource = (source, edit) => {
        let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
        let links_section = routes.find(section => section.id === 'links')
        let links = links_section.screens

        return (
            <Paper key = {source.link_id} variant = 'outlined' style = {{width : '100%', padding : '10px', marginBottom : '10px'}}>
                <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                    <div style = {{flexGrow : 1}}>
                            <FormControl style = {{width : '50%'}} disabled = {!edit}>
                            <InputLabel id="demo-simple-select-label">Link</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value = {source.link_id}
                                onChange = {(event) => {
                                    let sources = [...this.state.external_sources]
                                    let update_source_index = sources.findIndex(src => src.link_id === source.link_id)

                                    let link_index = links.findIndex(link => link.id === event.target.value)
                                    let query_map = links[link_index].default_params.query_params.map(qp => {
                                        return {
                                            key_name : qp.key,
                                            value_map : []
                                        }
                                    })

                                    if (update_source_index !== -1) {
                                        sources[update_source_index].link_id = event.target.value
                                        sources[update_source_index].link_name = links[link_index].name
                                        sources[update_source_index].query_map = query_map
                                        this.setState({...this.state, external_sources : sources})
                                    }
                                }}
                            >
                                {links.map(link => {
                                    return (
                                        <MenuItem value={link.id}>{link.name}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </div>
                    <div>
                        <IconButton 
                            disabled = {!edit}
                            size = 'small' 
                            color = 'secondary' 
                            onClick = {() => this.deleteExternalSource(source.id)}>
                            <Clear fontSize = 'small'/>
                        </IconButton>
                    </div>
                </div>
                {source.query_map.length > 0 && <div style = {{marginTop : '10px', padding : '5px'}}>
                    <Typography style = {{margin : '5px'}} variant = 'overline'>Query Parameters</Typography>
                    {source.query_map.map(qm => {
                        return (
                            <Paper variant = 'outlined' style = {{width : '100%', display : 'flex', marginBottom : '10px', flexDirection : 'row', alignItems : 'center'}}>
                                <div style = {{width : '40%', padding : '5px'}}>
                                    <Typography variant = 'caption'>Key Name</Typography>
                                    <Typography style = {{margin : '5px'}} variant = 'subtitle2'>{qm.key_name}</Typography>
                                </div>
                                <div style = {{width : '60%', padding : '5px'}}>
                                    <FormControl style = {{width : '100%'}} disabled = {!edit}>
                                        <InputLabel id="demo-simple-select-label">Param Value</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            multiple
                                            value={qm.value_map}
                                            input={<Input id="select-multiple-chip" />}
                                            renderValue={(selected) => (
                                                <div>
                                                  {selected.map((value) => (
                                                    <Chip key={value} style = {{marginLeft: '5px'}} label={value}/>
                                                  ))}
                                                </div>
                                              )}
                                            onChange = {(event) => {
                                                console.log("Updating Source : ", event.target.value)
                                                let sources = [...this.state.external_sources]
                                                let update_source_index = sources.findIndex(src => src.link_id === source.link_id)

                                                if (update_source_index !== -1) {
                                                    let qm_index = sources[update_source_index].query_map.findIndex(query => query.key_name === qm.key_name)
                                                    sources[update_source_index].query_map[qm_index].value_map = event.target.value
                                                    console.log("Updated Source : ", sources[update_source_index])
                                                    this.setState({...this.state, external_sources : sources})
                                                }
                                            }}
                                        >
                                            {this.state.search_type === 'freetext' ? <MenuItem value={'searchtext'}>Search Text</MenuItem> :
                                                this.state.search_fields.map(field => {
                                                    return (
                                                        <MenuItem value={field.name}>{field.name}</MenuItem>
                                                    )
                                                })}
                                        </Select>
                                    </FormControl>
                                </div>
                            </Paper>
                        )
                    })}
                </div>}
            </Paper>
        )
    }

    renderCTA = (edit) => {
        return (
            <CTAConfig
                screen_config = {this.props.config}
                ic_list = {this.props.ic_list}
                selected_ic_list = {this.state.selected_ic_list}
                external_ic = {null}
                external_iu = {null}
                cta_config = {this.state.cta_config}
                screen_cta_config  = {this.state.screen_cta_config}
                edit = {edit}
                set_cta = {(cta_config) => this.setState({...this.state, cta_config : cta_config})}
                set_screen_cta = {(screen_cta_config) => {
                    console.log('Setting Screen CTA : ', screen_cta_config)
                    this.setState({...this.state, screen_cta_config : screen_cta_config})}
                }
            />
        )
    }


    renderTabContent = (edit) => {
        if (this.state.search_type === 'freetext') {
            switch (this.state.setting_tab_index) {
                case 0 :
                  return this.renderSettingsTabContent(edit)
                case 1:
                  return this.renderDeeplinksTabContent(edit)
                case 2:
                    return this.renderFiltersTabContent(edit)
                case 3:
                    return this.renderExternalSources(edit)
                case 4:
                    return this.renderCTA(edit)
                default :
                  return null
            }
        } else {
            switch (this.state.setting_tab_index) {
                case 0 :
                  return this.renderSettingsTabContent(edit)
                case 1:
                    return this.renderFieldMapsTabContent(edit)
                case 2:
                  return this.renderDeeplinksTabContent(edit)
                case 3:
                    return this.renderFiltersTabContent(edit)
                case 4:
                    return this.renderExternalSources(edit)
                case 5:
                    return this.renderCTA(edit)
                default :
                  return null
            }
        }
    }

    handleTabChange = (event, newValue) => {
        this.setState({...this.state, setting_tab_index : newValue})
    }

    renderSettings = (edit) => {
        return (
            <div style = {{width : '100%'}}>
                <AntTabs
                    value={this.state.setting_tab_index}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.handleTabChange}
                    aria-label="Display Config Tabs"
                >
                    <AntTab label="Search Settings" disabled = {!this.isValid()}/>
                    {this.state.search_type === 'multifield' && <AntTab label="Field Maps" disabled = {!this.isValid()}/>}
                    <AntTab label="Deeplinks" disabled = {!this.isValid()}/>
                    <AntTab label="Filters" disabled = {!this.isValid()}/>
                    <AntTab label="External Sources" disabled = {!this.isValid()}/>
                    <AntTab label="Call To Action" disabled = {!this.isValid()}/>
                </AntTabs>
                {this.renderTabContent(edit)}
            </div>
        )
    }

    renderSubmit = (edit) => {
        if (edit) {
            return (
                <div style = {{width : '100%', display : 'flex', flexDirection : 'row-reverse', padding : '5px', borderTop: '1px solid rgba(0,0,0,0.12)'}}>
                    <Button
                        disabled = {!this.isValid()}
                        variant = "contained"
                        color = 'primary'
                        size = 'small'
                        onClick = {() => {
                            this.setState({...this.state, show_settings : false}, () => {
                                this.props.update(this.generateConfigFromState())
                            })
                        }}
                    >Submit</Button>
                    <Button
                        style = {{marginRight : '5px'}}
                        variant = "contained"
                        color = 'secondary'
                        size = 'small'
                        onClick = {() => {
                                if (this.state.name === null || this.state.selected_ic_list.length === 0) {
                                    this.setState({...this.state, show_settings : false}, () => {
                                        this.props.delete(this.props.config)
                                    })
                                } else { 
                                    this.setState({...this.state, show_settings : false}, () => {
                                        this.generateStateFromConfig()
                                        this.props.update(this.props.config)
                                    })
                                }
                        }}
                    >Cancel</Button>
                </div>
            )
        }
    }

    validateEmptyString = (Name) => {
        const re = /^(?!\s*$).+/;
        return re.test(String(Name));
      };

    renderSearchScreen = (edit) => {
        return (
            <Paper style = {{width : '100%', marginTop : '10px'}}>
                <div style = {{width : '100%', padding: '10px', display : 'flex', flexDirection : 'row', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                    <div style = {{margin : '5px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'center'}}>
                        <Tooltip title = 'Show Settings' >
                            <IconButton onClick = {() => this.updateState('show_settings', !this.state.show_settings)}>
                                {this.state.show_settings ? <ExpandLess fontSize = 'small'/> : <ExpandMore fontSize = 'small'/>}
                            </IconButton>
                        </Tooltip>
                    </div>
                    {this.renderName(edit)}
                    {this.renderICList(edit)}
                    {this.renderActions(edit)}
                </div>
                <Collapse in = {this.state.show_settings}>
                    {this.renderSettings(edit)}
                </Collapse>
                {this.renderSubmit(edit)}
            </Paper>
        )
    }

    render() { 
        console.log("Selected IC Object List : ", this.state.selected_ic_object_list)
        return (
            <ThemeProvider theme = {blue_theme}>
                {this.renderSearchScreen(this.props.editing_id === this.props.config.id ? true : false)}
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(SearchScreen);